import { useLayoutEffect, useRef, useState } from "react";
import styled from "styled-components";
import { getBaseUrl } from "../LandingOne";

const navItems = [
  { title: "Our Services", targetId: "stat-section" },
  { title: "Our Mission", targetId: "explore-more-section" }
];

const scrollToSection = (targetId: string) => (
  event: React.MouseEvent<HTMLAnchorElement>
) => {
  event.preventDefault();
  const targetElement = document.getElementById(targetId);
  if (targetElement) {
    targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

const LandingHeader = () => {
  const signInUrl = getBaseUrl();
  const headerRef = useRef<HTMLElement>(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  useLayoutEffect(() => {
    const updateHeight = () => {
      if (headerRef.current) {
        setHeaderHeight(headerRef.current.offsetHeight);
      }
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  return (
    <>
      <Header ref={headerRef}>
        <NavLinks>
          {navItems.map((item) => (
            <NavLink key={item.title} href={`#${item.targetId}`} onClick={scrollToSection(item.targetId)}>
              {item.title.toUpperCase()}
            </NavLink>
          ))}
        </NavLinks>

        <LogoLink href="/">
          <LogoImage src="/assets/img/logo_dark.png" alt="Majura" />
        </LogoLink>

        <Actions>
          <SignInButton href={signInUrl}>Sign in</SignInButton>
          <RequestDemoButton href="#contact-section" onClick={scrollToSection("contact-section")}>
            Request demo
          </RequestDemoButton>
        </Actions>
      </Header>
      <HeaderSpacer style={{ height: headerHeight }} />
    </>
  );
};

const HeaderSpacer = styled.div`
  width: 100%;
`;

const Header = styled.header`
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
  padding: 20px 48px;
  background: transparent;

  @media (max-width: 900px) {
    padding: 16px 24px;
  }
`;

const NavLinks = styled.nav`
  display: flex;
  align-items: center;
  gap: 32px;
  flex: 1;

  @media (max-width: 767px) {
    display: none;
  }
`;

const NavLink = styled.a`
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 1px;
  color: #4b5a76;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: #0b1c75;
  }
`;

const LogoLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LogoImage = styled.img`
  height: 28px;
  width: auto;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  flex: 1;

  @media (max-width: 767px) {
    flex: 0;
  }
`;

const SignInButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 24px;
  border-radius: 999px;
  border: 1px solid #c7d0e6;
  color: #0b1c75;
  font-size: 0.95rem;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    border-color: #0b1c75;
  }

  @media (max-width: 600px) {
    display: none;
  }
`;

const RequestDemoButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 26px;
  border-radius: 999px;
  background: #4c5cf0;
  color: #fff;
  font-size: 0.95rem;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    background: #3d4de0;
  }
`;

export default LandingHeader;
